import { render } from "./OpenBlog.vue?vue&type=template&id=ba1dd13e"
import script from "./OpenBlog.vue?vue&type=script&lang=js"
export * from "./OpenBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__